<template>
  <div class="brain">
    <div class="page-wrapper chiller-theme toggled">
      <Sidenav />
      <Headernav />
      <div class="brain-children">
        <router-view></router-view>
      </div>
    </div>
    <!-- page-wrapper -->
  </div>
</template>

<script>
import Sidenav from "../../../components/Sidenav/Sidenav4.vue";
import Headernav from "../../../components/Header/Headernav.vue";

export default {
  name: "Brain",
  components: {
    Sidenav,
    Headernav
  }
};
</script>

<style scoped></style>
